import React, {
  useEffect,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  useParams,
} from "react-router-dom";

import {
  useStateContext,
} from "../../context/ContextProvider";

import {
  DLabel,
  Select,
  DSpinButton,
  TextArea,
} from "../utils/Form";

import {
  getAllCategorys,
} from "../../redux/actions/category";

import {
  getMeal,
  updateMeal,
} from "../../redux/actions/meals";

import {
  toast,
} from "react-toastify";

import {
  Loader,
} from "../utils";

import {
  media,
} from "../../server";

import ImageUploadWithResize
  from "../../utils/ImageUploadWithResize";


function EditMeal() {
  const {
    t,
  } = useTranslation();

  const {
    currentColor,
  } = useStateContext();

  const dispatch =
    useDispatch();

  const {
    id,
  } = useParams();


  /* =====================================
      REDUX
  ====================================== */

  const {
    mealData,
    isLoadingmeal,
  } = useSelector(
    (state) =>
      state.Meals
  );


  const {
    isLoading,
    AllCategorys,
  } = useSelector(
    (state) =>
      state.Categorys
  );


  /* =====================================
      STATES
  ====================================== */

  const [
    isSpinner,
    setIsSpinner,
  ] = useState(false);


  const [
    titleAr,
    setTitleAr,
  ] = useState("");


  const [
    titleEn,
    setTitleEn,
  ] = useState("");


  const [
    textAr,
    setTextAr,
  ] = useState("");


  const [
    textEn,
    setTextEn,
  ] = useState("");


  const [
    categoryId,
    setCategoryId,
  ] = useState("");


  const [
    price,
    setPrice,
  ] = useState("");


  const [
    preparationTime,
    setPreparationTime,
  ] = useState("");


  /*
   * image:
   *
   * - إذا لم يغير المستخدم الصورة:
   *   تحتوي على اسم الصورة القديمة.
   *
   * - إذا اختار صورة جديدة:
   *   تصبح File.
   */

  const [
    image,
    setImage,
  ] = useState(null);


  const [
    imageShow,
    setImageShow,
  ] = useState(null);


  /* =====================================
      FETCH MEAL + CATEGORIES
  ====================================== */

  useEffect(() => {
    dispatch(
      getMeal(id)
    );

    dispatch(
      getAllCategorys()
    );
  }, [
    dispatch,
    id,
  ]);


  /* =====================================
      SET MEAL DATA
  ====================================== */

  useEffect(() => {
    if (!mealData) {
      return;
    }


    setTitleAr(
      mealData?.titleAr || ""
    );


    setTitleEn(
      mealData?.titleEn || ""
    );


    setTextAr(
      mealData?.textAr || ""
    );


    setTextEn(
      mealData?.textEn || ""
    );


    /*
     * categoryId قد تأتي:
     *
     * Object populated
     * أو ObjectId فقط
     */

    setCategoryId(
      mealData?.categoryId?._id ||
        mealData?.categoryId ||
        ""
    );


    setPrice(
      mealData?.price ??
        ""
    );


    setPreparationTime(
      mealData?.preparationTime ??
        ""
    );


    setImage(
      mealData?.Image ||
        null
    );


    if (
      mealData?.Image
    ) {
      setImageShow({
        url: `${media}${mealData.Image}`,
      });
    } else {
      setImageShow(null);
    }

  }, [
    mealData,
  ]);


  /* =====================================
      VALIDATION
  ====================================== */

  const validateForm = () => {

    if (
      !titleAr.trim()
    ) {
      toast.error(
        t(
          "Arabic title is required"
        )
      );

      return false;
    }


    if (
      !titleEn.trim()
    ) {
      toast.error(
        t(
          "English title is required"
        )
      );

      return false;
    }


    if (
      !categoryId
    ) {
      toast.error(
        t(
          "Please select a category"
        )
      );

      return false;
    }


    if (
      !textAr.trim()
    ) {
      toast.error(
        t(
          "Arabic description is required"
        )
      );

      return false;
    }


    if (
      !textEn.trim()
    ) {
      toast.error(
        t(
          "English description is required"
        )
      );

      return false;
    }


    /*
     * هنا الصورة القديمة مقبولة.
     *
     * لذلك لا نشترط أن تكون File.
     */

    if (!image) {
      toast.error(
        t(
          "Please select an image"
        )
      );

      return false;
    }


    if (
      price !== "" &&
      Number(price) < 0
    ) {
      toast.error(
        t(
          "Price cannot be negative"
        )
      );

      return false;
    }


    if (
      preparationTime !== "" &&
      Number(
        preparationTime
      ) < 0
    ) {
      toast.error(
        t(
          "Preparation time cannot be negative"
        )
      );

      return false;
    }


    return true;
  };


  /* =====================================
      UPDATE MEAL
  ====================================== */

  const handleSubmit =
    async (e) => {

      e.preventDefault();


      if (isSpinner) {
        return;
      }


      if (
        !validateForm()
      ) {
        return;
      }


      try {
        setIsSpinner(
          true
        );


        const newForm =
          new FormData();


        /*
         * نرسل الصورة فقط إذا
         * قام المستخدم باختيار صورة جديدة.
         *
         * إذا كانت image مجرد String
         * فهذا يعني أنها الصورة القديمة.
         */

        if (
          image instanceof File
        ) {
          newForm.append(
            "file",
            image
          );
        }


        newForm.append(
          "categoryId",
          categoryId
        );


        newForm.append(
          "titleAr",
          titleAr.trim()
        );


        newForm.append(
          "titleEn",
          titleEn.trim()
        );


        newForm.append(
          "textAr",
          textAr.trim()
        );


        newForm.append(
          "textEn",
          textEn.trim()
        );


        /*
         * السعر
         */

        if (
          price !== ""
        ) {
          newForm.append(
            "price",
            Number(price)
          );
        } else {
          newForm.append(
            "price",
            0
          );
        }


        /*
         * مدة التحضير
         */

        if (
          preparationTime !==
          ""
        ) {
          newForm.append(
            "preparationTime",
            Number(
              preparationTime
            )
          );
        }


        /* =========================
           Redux Update
        ========================== */

        const updatedMeal =
          await dispatch(
            updateMeal(
              id,
              newForm
            )
          );


        /*
         * تحديث الصورة المعروضة
         * في حال تم تغييرها.
         */

        if (
          updatedMeal?.Image
        ) {
          setImage(
            updatedMeal.Image
          );

          setImageShow({
            url: `${media}${updatedMeal.Image}`,
          });
        }


        toast.success(
          <span
            className="
              font-kufi
              text-sm

              text-tcolor-4
              dark:text-tcolor-1
            "
          >
            {t(
              "Meal updated successfully!"
            )}
          </span>
        );


        /*
         * إعادة جلب الوجبة
         * لضمان مزامنة Redux
         */

        dispatch(
          getMeal(id)
        );

      } catch (error) {

        const errorMessage =
          error?.response
            ?.data?.message ||
          error?.message ||
          t(
            "An error occurred"
          );


        toast.error(
          <span
            className="
              font-kufi
              text-sm
            "
          >
            {errorMessage}
          </span>
        );

      } finally {

        setIsSpinner(
          false
        );

      }
    };


  /* =====================================
      LOADING
  ====================================== */

  if (
    isLoading ||
    isLoadingmeal
  ) {
    return <Loader />;
  }


  return (
    <div
      className="
        w-[92%]

        lg:w-[60%]
        xl:w-[52%]

        m-2
        md:m-10

        mt-24

        rounded-3xl

        bg-back-primery
        dark:bg-back-darksecondary

        p-4
        md:p-8
        lg:p-10

        shadow-[0_12px_40px_rgba(68,37,20,0.08)]
      "
    >

      {/* =================================
          HEADER
      ================================= */}

      <div
        className="
          mb-8

          pb-5

          border-b
          border-color-2/10
          dark:border-white/10
        "
      >

        <h3
          className="
            font-kufi
            font-semibold

            text-xl
            md:text-2xl

            text-color-1
          "
        >
          {t(
            "Edit Meal"
          )}
        </h3>


        <p
          className="
            mt-2

            font-kufi
            text-xs

            text-n-5
            dark:text-tcolor-3
          "
        >
          {t(
            "Update meal information"
          )}
        </p>

      </div>


      {/* =================================
          FORM
      ================================= */}

      <form
        onSubmit={
          handleSubmit
        }
      >

        {/* =================================
            MAIN INFO
        ================================= */}

        <div
          className="
            grid

            grid-cols-1
            md:grid-cols-2

            gap-x-5
          "
        >

          {/* Arabic Title */}

          <DLabel
            labelText="Title (Ar)"

            value={
              titleAr
            }

            onChange={(
              e
            ) =>
              setTitleAr(
                e.target.value
              )
            }

            required={
              true
            }

            type="text"

            name="titleAr"
          />


          {/* English Title */}

          <DLabel
            labelText="Title (En)"

            value={
              titleEn
            }

            onChange={(
              e
            ) =>
              setTitleEn(
                e.target.value
              )
            }

            required={
              true
            }

            type="text"

            name="titleEn"
          />


          {/* Price */}

          <DLabel
            labelText="Price"

            value={
              price
            }

            onChange={(
              e
            ) =>
              setPrice(
                e.target.value
              )
            }

            required={
              false
            }

            type="number"

            name="price"

            min="0"
          />


          {/* Preparation Time */}

          <DLabel
            labelText="Preparation Time"

            value={
              preparationTime
            }

            onChange={(
              e
            ) =>
              setPreparationTime(
                e.target.value
              )
            }

            required={
              false
            }

            type="number"

            name="preparationTime"

            min="0"
          />

        </div>


        {/* =================================
            CATEGORY
        ================================= */}

        <Select
          Data={
            AllCategorys
          }

          labelText={t(
            "Select Category"
          )}

          value={
            categoryId
          }

          setValue={
            setCategoryId
          }

          required={
            true
          }
        />


        {/* =================================
            DESCRIPTION AR
        ================================= */}

        <TextArea
          labelText={t(
            "Description (Ar)"
          )}

          value={
            textAr
          }

          onChange={(
            e
          ) =>
            setTextAr(
              e.target.value
            )
          }

          required={
            true
          }
        />


        {/* =================================
            DESCRIPTION EN
        ================================= */}

        <TextArea
          labelText={t(
            "Description (En)"
          )}

          value={
            textEn
          }

          onChange={(
            e
          ) =>
            setTextEn(
              e.target.value
            )
          }

          required={
            true
          }
        />


        {/* =================================
            IMAGE
        ================================= */}

        <div
          className="
            mt-5
          "
        >
          <ImageUploadWithResize
            imageShow={
              imageShow
            }

            setImageShow={
              setImageShow
            }

            setImage={
              setImage
            }

            currentColor={
              currentColor
            }

            label="Upload Image"

            /*
             * توجد صورة أصلًا أثناء التعديل،
             * لذلك تغيير الصورة ليس إلزاميًا.
             */

            required={
              false
            }

            maxWidth={
              1024
            }

            maxHeight={
              1024
            }

            quality={
              80
            }
          />
        </div>


        {/* =================================
            SUBMIT
        ================================= */}

        <div
          className="
            mt-8
          "
        >
          <DSpinButton
            isLoading={
              isSpinner
            }
          >
            {isSpinner
              ? t(
                  "Updating..."
                )
              : t(
                  "Edit"
                )}
          </DSpinButton>
        </div>

      </form>

    </div>
  );
}


export default EditMeal;